export const REQUEST_QUERY = 'REQUEST_QUERY'
export const RECEIVE_QUERY = 'RECEIVE_QUERY'
export const REQUEST_MUTATION = 'REQUEST_MUTATION'
export const RECEIVE_MUTATION = 'RECEIVE_MUTATION'
